(function() { window.GUID_4a679aa6_5bab_434a_9fee_1fd03684d5d2 = { getGuid: function() { return "4a679aa6-5bab-434a-9fee-1fd03684d5d2"; } }; })();
var PlayerStats;
(function (PlayerStats) {
    var desktop;
    (function (desktop) {
        $(function () {
            $('.CSDropDownCheckboxes').CSDropDownCheckboxes();
            BindElements();
        });
        function onSelectionChange(leaguesGrid, tournamentsGrid) {
            if (leaguesGrid == null || tournamentsGrid == null) {
                return;
            }
            const $btnTransferEntities = $("#BtnTransferEntities");
            const selectedRowsCount = leaguesGrid.SelectedRows.length + tournamentsGrid.SelectedRows.length;
            if (selectedRowsCount === 0) {
                $btnTransferEntities.addClass("IsDisabled");
            }
            else {
                $btnTransferEntities.removeClass("IsDisabled");
            }
            refreshChangePlayerNameButton();
        }
        function getSelectedHistoryPlayerCount() {
            return $("#HistoryPlayers").find(".PlayerYearHistoryBox").length;
        }
        function getChangePlayerNameEntityBaseId() {
            var _a, _b;
            const gridViewPlayerYearHistory = $("#GridViewPlayerYearHistory").data("context");
            const gridViewPlayerTournamentHistory = $("#GridViewPlayerTournamentHistory").data("context");
            if ((gridViewPlayerYearHistory === null || gridViewPlayerYearHistory === void 0 ? void 0 : gridViewPlayerYearHistory.SelectedRows.length) === 1) {
                const split = gridViewPlayerYearHistory.GetSelectedRowIds().split("_");
                return parseInt(split[1]);
            }
            if ((gridViewPlayerTournamentHistory === null || gridViewPlayerTournamentHistory === void 0 ? void 0 : gridViewPlayerTournamentHistory.SelectedRows.length) === 1) {
                const split = gridViewPlayerTournamentHistory.GetSelectedRowIds().split("_");
                const playerId = split[0].replace(/^[A-Za-z]+/, "");
                return parseInt(playerId);
            }
            const playerIds = (_b = (_a = $("#PlayerIds").val()) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "";
            const selectedPlayerIds = playerIds.split(",").filter((playerId) => playerId);
            if (selectedPlayerIds.length === 1) {
                return parseInt(selectedPlayerIds[0]);
            }
            return null;
        }
        function refreshChangePlayerNameButton() {
            const btnChangePlayerName = $("#BtnChangePlayerName");
            const hasSingleSelection = getSelectedHistoryPlayerCount() === 1;
            const hasSelectedGridRow = getChangePlayerNameEntityBaseId() != null;
            if (hasSingleSelection || hasSelectedGridRow) {
                btnChangePlayerName.removeClass("IsDisabled");
            }
            else {
                btnChangePlayerName.addClass("IsDisabled");
            }
        }
        function onBtnTransferEntitiesClick(leaguesGrid, tournamentsGrid) {
            if (!leaguesGrid || !tournamentsGrid) {
                return;
            }
            const entityRows = [];
            const getSportEventName = (rowId, grid) => grid.GetRowColumnValue(rowId, "SportEventName");
            const getStatGroupName = (rowId, grid) => grid.GetRowColumnValue(rowId, "StatGroupName");
            const getDisplayName = (rowId, grid) => grid.GetRowColumnValue(rowId, "DisplayName");
            const getFlowBlockName = (rowId, grid) => grid.GetRowColumnValue(rowId, "FlowBlockName");
            const leagueEntities = leaguesGrid.GetSelectedRowIds().split(",");
            leagueEntities
                .filter((rowId) => rowId && rowId != "")
                .forEach((rowId) => {
                const [eventId, playerId, statGroupId] = rowId.split("_");
                const EventId = parseInt(eventId);
                const StatGroupId = parseInt(statGroupId);
                const EntityBaseId = parseInt(playerId);
                if (!isNaN(EventId) && !isNaN(StatGroupId) && !isNaN(EntityBaseId)) {
                    entityRows.push({
                        EventId,
                        StatGroupId,
                        EntityBaseId,
                        SportEventName: getSportEventName(rowId, leaguesGrid),
                        StatGroupName: getStatGroupName(rowId, leaguesGrid),
                        DisplayName: getDisplayName(rowId, leaguesGrid),
                    });
                }
            });
            const tournamentEntities = tournamentsGrid.GetSelectedRowIds().split(",");
            tournamentEntities
                .filter((rowId) => rowId && rowId != "")
                .forEach((rowId) => {
                const [personaId, flowBlockId, eventId] = rowId.split("_");
                const playerId = personaId.replace(/^[A-Za-z]+/, "");
                const EventId = parseInt(eventId);
                const FlowBlockId = parseInt(flowBlockId);
                const EntityBaseId = parseInt(playerId);
                if (!isNaN(EventId) && !isNaN(FlowBlockId) && !isNaN(EntityBaseId)) {
                    entityRows.push({
                        EventId,
                        FlowBlockId,
                        EntityBaseId,
                        SportEventName: getSportEventName(rowId, tournamentsGrid),
                        FlowBlockName: getFlowBlockName(rowId, tournamentsGrid),
                        DisplayName: getDisplayName(rowId, tournamentsGrid),
                    });
                }
            });
            const playerBoxes = [];
            const $players = $("#HistoryPlayers").find(".PlayerYearHistoryBox");
            if ($players === null || $players === void 0 ? void 0 : $players.length) {
                $players.each((_, player) => {
                    const $player = $(player);
                    const playerId = $player.data("id");
                    if (playerId) {
                        playerBoxes.push({
                            PlayerId: playerId,
                            PlayerName: $player.text().trim(),
                        });
                    }
                });
            }
            const data = {
                entityRows: entityRows.map((entity) => JSON.stringify(entity)),
                playerBoxes: playerBoxes.map((player) => JSON.stringify(player)),
            };
            const popup = new CompuSport.Controls.Popup();
            popup.OnShowed = () => {
                const playerEntityTransferer = new CompuSport.Controls.PlayerEntityTransferer(popup);
                playerEntityTransferer.initialize();
            };
            popup.GetAndShow({
                PopupId: "PlayerEntityTransfererPopup",
                Url: CSParameters.RUrl + "Shared/PlayerEntityTransfererPopup",
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET,
            });
            popup.OnPosted = function (response) {
                tournamentsGrid.RefreshGridData();
                leaguesGrid.RefreshGridData();
            };
        }
        function BindElements() {
            var btnShowTeams = $('#BtnShowTeams');
            var btnShowHistory = $('#BtnShowHistory');
            var btnShowHistoryPlayerYearHistory = $('#BtnShowHistoryPlayerYearHistory');
            var btnEmbedStats = $('#BtnEmbedStats');
            var btnLinkFullScreenStats = $('#BtnLinkFullScreen');
            var divPlayerCard = $('#PlayerCard');
            var playerCard = $('.PlayerCard', divPlayerCard);
            var messageMiddleCard = $('.MessageMiddleCard', divPlayerCard);
            var pubsRotator = $('#PubsRotator');
            var btnAddToAssociation = $('#BtnAddToAssociation');
            var btnMergePlayers = $('#BtnMergePlayers');
            var btnSendMergePlayersRequest = $('#BtnSendMergePlayersRequest');
            var btnAverageHistory = $('#BtnAverageHistory');
            var btnLeagueStats = $('#BtnLeagueStats');
            var btnTournamentPage = $('#BtnTournamentPage');
            var btnUpdateEncounterStatSG = $('#BtnUpdateEncounterStatSG');
            const btnTransferEntities = $("#BtnTransferEntities");
            let gridViewPlayerStatsUI = $('#GridViewPlayerStats');
            let gridViewPlayerStats = gridViewPlayerStatsUI.data('context');
            var btnShowGameHistory = $('#BtnShowGameHistory');
            var btnRatingHistory = $('#BtnRatingHistory');
            var btnCSRGraph = $('#BtnCSRGraph');
            var btnChangeStartRating = $('#BtnChangeStartRating');
            var btnChangePlayerName = $('#BtnChangePlayerName');
            let autoSearchPlayers = $('#autocompletePlayerId');
            $('#GridViewPlayerYearHistory').controlIsLoaded(function (gridView) {
                var gridViewTournamentsHistory = gridView;
                RefreshButtonsPlayerYearHistory();
            });
            CS.body.on('Refreshed', '#GridViewPlayerStats', function (e, gridView) {
                gridViewPlayerStats = gridView;
            });
            btnShowGameHistory.on('click', 'a', function (e) {
                e.preventDefault();
                var data = {
                    entityBaseId: $("#PlayerIds").val()
                };
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "",
                    Url: CSParameters.RUrl + 'CSRStartingRate/ShowGameHistory',
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                });
            });
            btnRatingHistory.on('click', 'a', function (e) {
                e.preventDefault();
                var data = {
                    entityBaseId: $("#PlayerIds").val()
                };
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "",
                    Url: CSParameters.RUrl + 'CSRStartingRate/ShowRatingHistory',
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                });
            });
            btnCSRGraph.on('click', 'a', function (e) {
                e.preventDefault();
                CompuSport.Ajax.Get(CSParameters.RUrl + 'CSRStartingRate/ShowCSRGraph', { entityBaseId: $("#PlayerIds").val() }, function (response) {
                    if (response.error) {
                        alert(response.error);
                    }
                    else {
                        CS.ShowCSRGraph(response);
                    }
                });
            });
            btnChangeStartRating.on('click', 'a', function (e) {
                e.preventDefault();
                var data = {
                    playerIds: $("#PlayerIds").val()
                };
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "StartRatingInputBox",
                    Url: CSParameters.RUrl + 'CSRStartingRate/StartRatingInputBox/' + CSParameters.SportEventId,
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
                });
            });
            let gridViewPlayerYearHistoryUI = $('#GridViewPlayerYearHistory');
            let gridViewPlayerYearHistory = gridViewPlayerYearHistoryUI.data('context');
            let gridViewPlayerTournamentHistoryUI = $('#GridViewPlayerTournamentHistory');
            let gridViewPlayerTournamentHistory = gridViewPlayerTournamentHistoryUI.data('context');
            CS.body.on('Refreshed', '#GridViewPlayerYearHistory', function (e, gridView) {
                gridViewPlayerYearHistory = gridView;
            });
            CS.body.on('Refreshed', '#GridViewPlayerTournamentHistory', function (e, gridView) {
                gridViewPlayerTournamentHistory = gridView;
                RefreshButtonsPlayerYearHistory();
            });
            if (gridViewPlayerYearHistory != null) {
                gridViewPlayerYearHistory.SelectionChange = function () {
                    if (gridViewPlayerYearHistory.SelectedRows.length == 1) {
                        btnLeagueStats.removeClass('IsDisabled');
                        btnShowHistoryPlayerYearHistory.removeClass('IsDisabled');
                    }
                    else {
                        btnLeagueStats.addClass('IsDisabled');
                        btnShowHistoryPlayerYearHistory.addClass('IsDisabled');
                    }
                    onSelectionChange(gridViewPlayerYearHistory, gridViewPlayerTournamentHistory);
                };
            }
            if (gridViewPlayerTournamentHistory != null) {
                gridViewPlayerTournamentHistory.SelectionChange = function () {
                    if (gridViewPlayerTournamentHistory.SelectedRows.length == 1) {
                        btnTournamentPage.removeClass('IsDisabled');
                    }
                    else {
                        btnTournamentPage.addClass('IsDisabled');
                    }
                    onSelectionChange(gridViewPlayerYearHistory, gridViewPlayerTournamentHistory);
                };
            }
            btnTransferEntities.on("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                onBtnTransferEntitiesClick(gridViewPlayerYearHistory, gridViewPlayerTournamentHistory);
            });
            var btnRefresh = $('#BtnRefresh');
            btnRefresh.off('click');
            btnRefresh.on('click', function (e) {
                e.preventDefault();
                if (gridViewPlayerYearHistory != null) {
                    RefreshTwoGridsPlayerYearHistory();
                }
                else {
                    gridViewPlayerStats.RefreshGridData();
                }
            });
            btnMergePlayers.off('click');
            btnSendMergePlayersRequest.off('click');
            btnAddToAssociation.off('click');
            btnMergePlayers.off('click');
            btnShowTeams.off('click');
            btnShowHistory.off('click');
            btnShowHistoryPlayerYearHistory.off('click');
            btnAverageHistory.off('click');
            btnLeagueStats.off('click');
            btnTournamentPage.off('click');
            btnUpdateEncounterStatSG.off('click');
            btnChangePlayerName.off('click');
            btnTournamentPage.on('click', 'a', function (e) {
                e.preventDefault();
                var split = gridViewPlayerTournamentHistory.GetSelectedRowIds().split('_');
                var playerId = split[0];
                var eventId = split[2];
                if (playerId != undefined) {
                    var data = {
                        playerId: playerId
                    };
                    var reportParam = "?callFromHomePage=True&searchtype=Entity&entityId=" + data.playerId;
                    var url = CSParameters.RUrl + "GeneralSearch/Index/" + eventId + reportParam;
                    window.open(url, "_blank");
                }
            });
            btnChangePlayerName.on("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (btnChangePlayerName.hasClass('IsDisabled')) {
                    return false;
                }
                const playerId = getChangePlayerNameEntityBaseId();
                if (playerId == null) {
                    return false;
                }
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "",
                    Url: CSParameters.RUrl + 'Persons/ChangePlayerName/-1', /*volontaire de mettre moins 1 car ca essaye de chercher les joueurs potentiel par rapport au event en cours.  cette page la n'en a pas.*/
                    Data: {
                        Post: true,
                        entityBaseId: playerId
                    },
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
                });
                popup.OnPosted = function () {
                    gridViewPlayerYearHistory.RefreshGridData();
                    gridViewPlayerTournamentHistory.RefreshGridData();
                };
            });
            btnLeagueStats.on('click', 'a', function (e) {
                e.preventDefault();
                var split = gridViewPlayerYearHistory.GetSelectedRowIds().split('_');
                var eventId = split[0];
                var playerId = split[1];
                var statGroupId = split[2];
                if (playerId != undefined) {
                    var data = {
                        playerId: playerId,
                        statGroupId: statGroupId
                    };
                    var reportParam = "?entityBaseId=" + data.playerId + "&statGroupId=" + data.statGroupId;
                    var url = CSParameters.RUrl + "PlayerStats/Index/" + eventId + reportParam;
                    window.open(url, "_blank");
                }
            });
            btnShowHistoryPlayerYearHistory.on('click', 'a', function (e) {
                e.preventDefault();
                var split = gridViewPlayerYearHistory.GetSelectedRowIds().split('_');
                var eventId = split[0];
                var playerId = split[1];
                var statGroupId = split[2];
                if (playerId != undefined) {
                    var data = {
                        playerId: playerId,
                        statGroupId: statGroupId
                    };
                    let popup = new CompuSport.Controls.Popup();
                    popup.GetAndShow({
                        PopupId: "",
                        Url: CSParameters.RUrl + 'PlayerStats/ShowPlayerHistory/' + eventId,
                        Data: { playerId: playerId, selectedStatGroupId: statGroupId },
                        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                    });
                }
            });
            if (gridViewPlayerStats != null) {
                gridViewPlayerStats.SelectionChange = function () {
                    if (this.SelectedRows.length > 0) {
                        var split = this.GetSelectedRowIds().split('_');
                        var playerId = split[1];
                        if (playerCard.length > 0) {
                            var playerCardUrl = CSParameters.RUrl + "PlayerCard/" + CSParameters.SportEventId + "/" + $("#SelectedStatGroupId").control().GetSelectedItemValue("value") + "/" + playerId + "/55/";
                            playerCard[0].src = playerCardUrl;
                            messageMiddleCard.html('Loading...');
                            playerCard.show();
                            messageMiddleCard.show();
                        }
                        if (this.SelectedRows.length == 1) {
                            btnShowTeams.removeClass('IsDisabled');
                            btnShowHistory.removeClass('IsDisabled');
                            btnAverageHistory.removeClass('IsDisabled');
                        }
                        else {
                            btnShowHistory.addClass('IsDisabled');
                            btnShowTeams.addClass('IsDisabled');
                            btnAverageHistory.addClass('IsDisabled');
                        }
                    }
                    else {
                        if (playerCard.length > 0) {
                            playerCard.hide();
                            messageMiddleCard.hide();
                        }
                        btnShowTeams.addClass('IsDisabled');
                        btnShowHistory.addClass('IsDisabled');
                        btnAverageHistory.addClass('IsDisabled');
                    }
                    refreshChangePlayerNameButton();
                };
            }
            btnUpdateEncounterStatSG.on('click', 'a', function (e) {
                e.preventDefault();
                let data = {};
                var statGroupId = $("#SelectedStatGroupId").control().GetSelectedItemValue("value");
                data.statgroupId = statGroupId;
                CompuSport.Controls.Popup.ShowConfirmDialogV2('', JSRess.AreYouSure, function () {
                    CompuSport.Ajax.Post(CSParameters.RUrl + "StatModelEditor/UpdateEncounterStat/" + CSParameters.SportEventId, data, function (queryResult) {
                        gridViewPlayerStats.RefreshGridData();
                    });
                });
            });
            var flowBlockNotes = $('#FlowBlockNotes');
            if (flowBlockNotes.length > 0) {
                //$("#SelectedStatGroupId").SelectionChange = function () {
                $("#SelectedStatGroupId").controlIsLoaded(function (SelectedStatGroupId) {
                    SelectedStatGroupId.SelectionChange = function (dropdown) {
                        if (dropdown.GetSelectedItemValue("value") != null) {
                            var data = {
                                statGroupId: dropdown.GetSelectedItemValue("value")
                            };
                            CompuSport.Ajax.Get(CSParameters.RUrl + "PlayerStats/GetFlowBlockNote/" + CSParameters.SportEventId, data, function (queryResult) {
                                $('#FlowBlockNotes')[0].innerText = queryResult;
                            });
                        }
                    };
                });
            }
            if (pubsRotator.length > 0) {
                pubsRotator.fadeIn(1000);
                document.PubsRotator.Cycle();
            }
            btnShowTeams.on('click', 'a', function (e) {
                e.preventDefault();
                var split = gridViewPlayerStats.GetSelectedRowIds().split('_');
                var playerId = split[1];
                if (playerId != undefined) {
                    let popup = new CompuSport.Controls.Popup();
                    popup.GetAndShow({
                        PopupId: "",
                        Url: CSParameters.RUrl + 'PlayerStats/ShowTeams/' + CSParameters.SportEventId,
                        Data: { playerId: playerId },
                        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                    });
                    //ShowFormPopup(CSParameters.RUrl + 'PlayerStats/ShowTeams/' + CSParameters.SportEventId + '?playerId=' + playerId, null);
                }
            });
            btnShowHistory.on('click', 'a', function (e) {
                e.preventDefault();
                var split = gridViewPlayerStats.GetSelectedRowIds().split('_');
                var playerId = split[1];
                var statGroupId = $("#SelectedStatGroupId").control().GetSelectedItemValue("value");
                if (playerId != undefined) {
                    let popup = new CompuSport.Controls.Popup();
                    popup.GetAndShow({
                        PopupId: "",
                        Url: CSParameters.RUrl + 'PlayerStats/ShowPlayerHistory/' + CSParameters.SportEventId,
                        Data: { playerId: playerId, selectedStatGroupId: statGroupId },
                        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                    });
                    //ShowFormPopup(CSParameters.RUrl + 'PlayerStats/ShowPlayerHistory/' + CSParameters.SportEventId + '?playerId=' + playerId, null);
                }
            });
            btnAverageHistory.on('click', 'a', function (e) {
                e.preventDefault();
                var split = gridViewPlayerStats.GetSelectedRowIds().split('_');
                var playerId = split[1];
                var statGroupId = $("#SelectedStatGroupId").control().GetSelectedItemValue("value");
                if (playerId != undefined) {
                    var data = {
                        playerId: playerId,
                        statGroupId: statGroupId
                    };
                    var reportParam = "?entityBaseId=" + data.playerId + "&statGroupId=" + data.statGroupId;
                    var url = CSParameters.RUrl + "PlayerStats/ExportAverageDetail/" + CSParameters.SportEventId + reportParam;
                    window.location.replace(url);
                    CS.win.trigger("downloadfinished");
                }
            });
            btnAddToAssociation.on('click', 'a', function (e) {
                e.preventDefault();
                var data = {
                    Post: true,
                    personids: $("#PlayerIds").val()
                };
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "",
                    Url: CSParameters.RUrl + 'PlayerStats/AddToAssociation/' + CSParameters.SportEventId,
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
                });
            });
            btnLinkFullScreenStats.on('click', 'a', function (e) {
                e.preventDefault();
                ShowEmbeddedStatsPopupInfo(true);
            });
            btnEmbedStats.on('click', 'a', function (e) {
                e.preventDefault();
                ShowEmbeddedStatsPopupInfo(false);
            });
            autoSearchPlayers.on('CSChange', function (e, autocomplete) {
                //CS.on('CSChange', '#autocompletePlayerId', function (e, autocomplete) {
                if (autocomplete.val() != "0" && autocomplete.val() != "") {
                    var item = autocomplete.SelectedItem.value;
                    autocomplete.ClearValue();
                    var otherPlayerIds = "";
                    var otherPlayerIdAndNames = "";
                    var htmltoadd = "";
                    /*obtenir les ids des joueurs linkés.*/
                    var data = {
                        entitybaseIds: item.id
                    };
                    if ($("#PlayerIds").val() == "") {
                        $("#PlayerIds").val(item.id);
                    }
                    else {
                        var pid = $("#PlayerIds").val();
                        pid = pid + "," + item.id;
                        $("#PlayerIds").val(pid);
                    }
                    CompuSport.Ajax.Post(CSParameters.BaseUrl + "PlayerStats/GetLinkedPlayerId/" + CSParameters.SportEventId, data, function (result) {
                        otherPlayerIdAndNames = result.otherIds;
                        htmltoadd = result.htmlitemToAdd;
                        if (otherPlayerIdAndNames != "") {
                            var pid = $("#PlayerIds").val();
                            var otherIdSplit = otherPlayerIdAndNames.split(',');
                            for (let i = 0; i < otherIdSplit.length; i++) {
                                let idAndName = otherIdSplit[i].split(';');
                                let ieb = parseInt(idAndName[0]);
                                pid = pid + "," + ieb;
                            }
                            $("#PlayerIds").val(pid);
                            autoSearchPlayers.data('context').AutoComplete.autocomplete("search", autocomplete.beforeSelectionText);
                        }
                        //var playerBox = $('<div class="PlayerYearHistoryBox" data-tooltip="' + item.id + '" data-id="' + item.id + '"><div class="RemoveButton">X</div>' + item.label + '</div>');
                        //var playerBox = $('<div class="PlayerYearHistoryBox" data-tooltip="' + item.id + '" data-id="' + item.id + '"><div class="RemoveButton">X</div><div class= "PlayerName">' + item.label + '<img class="PlayerEdit" src="../../Images/GridView/Edit.png"/></div></div>');
                        $('#HistoryPlayers').append(htmltoadd);
                        let plrids = $("#PlayerIds").val();
                        var btnclear = $(".ClearPlayerYearHistoryBox");
                        if (plrids != "" && plrids.split(',').length >= 1 && btnclear.length == 0) {
                            var ClearButton = $('<div class="ClearPlayerYearHistoryBox"><div class="ClearSearch">Clear</div></div>');
                            $('#HistoryPlayers').prepend(ClearButton);
                        }
                        else {
                        }
                        RefreshTwoGridsPlayerYearHistory();
                    });
                }
            });
            $('#HistoryPlayers').on('click', '.RemoveButton', function () {
                var playerBox = $(this).parent();
                playerBox.remove();
                RefreshTwoGridsPlayerYearHistory();
                let plrids = $("#PlayerIds").val();
                if (plrids != "" && plrids.split(',').length == 1) {
                    var clearPlayerBoxes = $('#HistoryPlayers').find('.ClearPlayerYearHistoryBox');
                    clearPlayerBoxes.remove();
                }
            });
            $('#HistoryPlayers').on('click', '.ClearSearch', function () {
                ClearSelectionPlayers();
            });
            function RefreshButtonsPlayerYearHistory() {
                let plrids = $("#PlayerIds").val();
                if (plrids != "") {
                    btnAddToAssociation.removeClass('IsDisabled');
                    btnChangeStartRating.removeClass('IsDisabled');
                    if (plrids.split(',').length == 1) {
                        btnShowGameHistory.removeClass('IsDisabled');
                        btnRatingHistory.removeClass('IsDisabled');
                        btnCSRGraph.removeClass('IsDisabled');
                    }
                    else {
                        btnShowGameHistory.addClass('IsDisabled');
                        btnRatingHistory.addClass('IsDisabled');
                        btnCSRGraph.addClass('IsDisabled');
                    }
                    if (plrids.split(',').length == 2) {
                        btnMergePlayers.removeClass('IsDisabled');
                    }
                    else {
                        btnMergePlayers.addClass('IsDisabled');
                    }
                    if (plrids.split(',').length >= 2) {
                        btnSendMergePlayersRequest.removeClass('IsDisabled');
                    }
                    else {
                        btnSendMergePlayersRequest.addClass('IsDisabled');
                    }
                }
                else {
                    btnAddToAssociation.addClass('IsDisabled');
                    btnMergePlayers.addClass('IsDisabled');
                    btnSendMergePlayersRequest.addClass('IsDisabled');
                    btnShowGameHistory.addClass('IsDisabled');
                    btnChangeStartRating.addClass('IsDisabled');
                    btnRatingHistory.addClass('IsDisabled');
                    btnCSRGraph.addClass('IsDisabled');
                }
                refreshChangePlayerNameButton();
            }
            let removePlayerTimer = null;
            function RefreshTwoGridsPlayerYearHistory() {
                $('#PlayerIds').val(GetPlayerBoxesIds());
                removePlayerTimer = CS.LagLocal(removePlayerTimer, 500, function () {
                    gridViewPlayerYearHistory.RefreshGridData();
                    gridViewPlayerTournamentHistory.RefreshGridData();
                });
            }
            function GetPlayerBoxesIds() {
                var playerBoxes = $('#HistoryPlayers').find('.PlayerYearHistoryBox');
                let playerIds = "";
                $.each(playerBoxes, function () {
                    var playerBox = $(this);
                    var id = playerBox.data('id');
                    playerIds += "," + id;
                });
                return playerIds.substr(1);
            }
            function ClearSelectionPlayers() {
                $("#PlayerIds").val("");
                $('#HistoryPlayers')[0].innerText = "";
                RefreshTwoGridsPlayerYearHistory();
            }
            function ShowEmbeddedStatsPopupInfo(justHyperlink) {
                var data = {
                    statGroupId: $("#SelectedStatGroupId").control().GetSelectedItemValue("value"),
                    justHyperlink: justHyperlink
                };
                CompuSport.Ajax.Get(CSParameters.BaseUrl + "PlayerStats/GetStatsEmbbededString/" + CSParameters.SportEventId, data, function (result) {
                    CompuSport.Controls.Popup.ShowWarningDialog(result);
                });
            }
            btnMergePlayers.on('click', 'a', function (e) {
                e.preventDefault();
                var data = {
                    Post: true,
                    personids: $("#PlayerIds").val()
                };
                let popup = new CompuSport.Controls.Popup();
                popup.GetAndShow({
                    PopupId: "",
                    Url: CSParameters.RUrl + 'PlayerOfAssociation/MergePlayers/' + CSParameters.SportEventId,
                    Data: data,
                    AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
                });
                popup.OnPosted = function (response) {
                    if (response.messages != undefined && response.messages != '') {
                        alert(response.messages);
                        /*obtenir les nouveaux ids.*/
                        window.location.assign(CSParameters.RUrl + 'PlayerStats/PlayerYearHistory/' + CSParameters.SportEventId);
                    }
                };
            });
            btnSendMergePlayersRequest.on('click', 'a', function (e) {
                e.preventDefault();
                var data = {
                    playerIds: $("#PlayerIds").val(),
                    notes: ""
                };
                CompuSport.Controls.Popup.ShowConfirmDialogV2('', "<div>Enter reason or special notes. Example: the correct spelling or the right lastname to use etc. </div><br><textarea cols='40' rows='8' class='CSDefault' type='text' id='mergenotes'></textarea>", function (popup) {
                    var text = $('#mergenotes', popup.Content).val();
                    data.notes = text;
                    //call ajax
                    CompuSport.Ajax.Post(CSParameters.RUrl + "PlayerStats/SendMergePlayersRequest/" + CSParameters.SportEventId, data, function (queryResult) {
                        ClearSelectionPlayers();
                        if (queryResult != "") {
                            CompuSport.Controls.Popup.ShowWarningDialog(queryResult);
                        }
                    });
                });
            });
        }
        desktop.BindElements = BindElements;
    })(desktop = PlayerStats.desktop || (PlayerStats.desktop = {}));
})(PlayerStats || (PlayerStats = {}));

//# sourceMappingURL=PlayerStats.js.map
